import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AUTH_PATHS = ['/dashboard', '/timeTracker', '/leaveManagement', '/time-tracker-request', '/shiftTime', '/calendar', '/profile', '/notifications', '/my-documents'];

export default function EmployeeModuleGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { allowedModules, loaded } = useSelector((state) => state.employeeModules);

  const allowedPaths = useMemo(() => {
    if (!loaded) return null;
    if (!allowedModules.length) return null;
    return new Set(
      allowedModules.flatMap((m) => (m.routes || []).map((r) => r.path))
    );
  }, [loaded, allowedModules]);

  const pathAllowed = useMemo(() => {
    if (!loaded || allowedPaths === null) return true;
    const path = location.pathname.replace(/\/$/, '') || '/dashboard';
    if (path === '/dashboard' || path === '/dashboard-new') return true;
    if (allowedPaths.has(path)) return true;
    return [...allowedPaths].some((p) => path.startsWith(p + '/'));
  }, [location.pathname, allowedPaths, loaded]);

  React.useEffect(() => {
    if (loaded && !pathAllowed) {
      navigate('/dashboard-new', { replace: true });
    }
  }, [loaded, pathAllowed, navigate]);

  return <>{children}</>;
}
